"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ShoppingProductCardPropTypes = exports.PromotionSubtitlePropTypes = exports.CardHeaderPropTypes = exports.CardFooterPropTypes = exports.CardBodyPropTypes = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

var _constant = require("@airasia/phoenix-components/components/Theme/constant");

var _constant2 = require("@airasia/phoenix-components/components/Text/constant");

var _constant3 = require("@airasia/phoenix-components/components/Link/constant");

var _constant4 = require("./constant");

var ShoppingProductCardPropTypes = {
  PropTypes: {
    data: _propTypes.default.shape({
      url: _propTypes.default.string,
      cta: _propTypes.default.string,
      primaryLabel: _propTypes.default.string,
      thumbnail: _propTypes.default.string,
      lowResolutionImageUrl: _propTypes.default.string,
      secondaryLabel: _propTypes.default.string,
      attractText: _propTypes.default.string,
      name: _propTypes.default.string,
      subtitle: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.instanceOf(Date)]),
      star: _propTypes.default.string,
      location: _propTypes.default.string,
      priceDisclaimer: _propTypes.default.string,
      discount: _propTypes.default.string,
      originalprice: _propTypes.default.string,
      price: _propTypes.default.string,
      priceClarification: _propTypes.default.string,
      rating: _propTypes.default.string,
      secondaryImage: _propTypes.default.string,
      labelColor: _propTypes.default.string,
      mobileAppImageURL: _propTypes.default.string,
      newTab: _propTypes.default.string,
      position: _propTypes.default.string,
      productID: _propTypes.default.string,
      hidden: _propTypes.default.string,
      productType: _propTypes.default.string,
      currencyCode: _propTypes.default.string,
      accessibilityText: _propTypes.default.string,
      cnDisclaimerLine1: _propTypes.default.string,
      cnDisclaimerLine2: _propTypes.default.string,
      cndisclaimerLine1: _propTypes.default.string,
      cndisclaimerLine2: _propTypes.default.string,
      chinaURL: _propTypes.default.string,
      companyURL: _propTypes.default.string,
      companyName: _propTypes.default.string,
      timer: _propTypes.default.string,
      timerEndDateTime: _propTypes.default.string,
      timerLabelEndDays: _propTypes.default.string,
      timerLabelEndHours: _propTypes.default.string,
      timerLabelStartDays: _propTypes.default.string,
      timerLabelStartHours: _propTypes.default.string,
      timerStartDateTime: _propTypes.default.string,
      timerTimeZone: _propTypes.default.string,
      formattedPrice: _propTypes.default.string,
      formattedOriginalPrice: _propTypes.default.string,
      colorButton: _propTypes.default.oneOf(_constant.ARR_COLORS),
      hoverColor: _propTypes.default.oneOf(_constant.ARR_COLORS),
      backgroundColor: _propTypes.default.oneOf(_constant.ARR_COLORS),
      hoverBackgroundColor: _propTypes.default.oneOf(_constant.ARR_COLORS),
      widthButton: _propTypes.default.string,
      customPropertiesButton: _propTypes.default.object,
      disabledButton: _propTypes.default.bool,
      ctaConfig: _propTypes.default.shape({
        color: _propTypes.default.oneOf(_constant.ARR_COLORS),
        size: _propTypes.default.oneOf(_constant.ARR_FONT_SIZE),
        target: _propTypes.default.oneOf(Object.keys(_constant3.LINK_TARGET)),
        type: _propTypes.default.oneOf(Object.keys(_constant3.REDIRECTION_TYPE)),
        href: _propTypes.default.string.isRequired,
        callback: _propTypes.default.func,
        queryParams: _propTypes.default.object
      }),
      promotionTnC: _propTypes.default.string,
      promotionCouponCode: _propTypes.default.string,
      couponBoxLabel: _propTypes.default.string,
      couponBoxCtaText: _propTypes.default.string,
      couponBoxCtaHref: _propTypes.default.string,
      subtitleExpandCtaText: _propTypes.default.string,
      tags: _propTypes.default.arrayOf(_propTypes.default.exact({
        key: _propTypes.default.string,
        label: _propTypes.default.string,
        url: _propTypes.default.string,
        color: _propTypes.default.oneOf(_constant.ARR_COLORS),
        backgroundColor: _propTypes.default.oneOf(_constant.ARR_COLORS),
        padding: _propTypes.default.string,
        margin: _propTypes.default.string,
        tagTarget: _propTypes.default.oneOf(Object.keys(_constant3.LINK_TARGET)),
        type: _propTypes.default.oneOf(_constant2.ARR_TEXT_TYPE),
        handleOnClick: _propTypes.default.func
      })),
      additionalText: _propTypes.default.string,
      overlayLabel: _propTypes.default.string,
      showOverlayBackGround: _propTypes.default.bool,
      imageList: _propTypes.default.string,
      pricePrefix: _propTypes.default.string
    }),
    index: _propTypes.default.string,
    fireGtm: _propTypes.default.func,
    gtmEventData: _propTypes.default.string,
    enableProgressiveImageLoading: _propTypes.default.bool,
    lazyLoadImage: _propTypes.default.bool,
    queryParams: _propTypes.default.object,
    theme: _propTypes.default.string,
    accessible: _propTypes.default.bool,
    environment: _propTypes.default.string,
    customProperties: _propTypes.default.object,
    width: _propTypes.default.string,
    columnSpan: _propTypes.default.oneOf(_constant4.ARR_COLUMN_SPAN),
    cardWidth: _propTypes.default.number,
    hoverEffect: _propTypes.default.bool,
    focusEffect: _propTypes.default.bool,
    handleClick: _propTypes.default.func,
    onMouseEnterEvent: _propTypes.default.func,
    imageHoverAnimation: _propTypes.default.bool,
    cardHeaderHeight: _propTypes.default.string,
    handleClickOnButton: _propTypes.default.func,
    showFormattedPrice: _propTypes.default.bool,
    chinaDisclaimerListener: _propTypes.default.func,
    allowLocaleFormat: _propTypes.default.bool,
    locale: _propTypes.default.string,
    localeConfig: _propTypes.default.shape({
      date: _propTypes.default.object,
      time: _propTypes.default.object
    }),
    isCnDomain: _propTypes.default.bool,
    isMobile: _propTypes.default.bool,
    handleCardVisibility: _propTypes.default.func,
    idConfig: _propTypes.default.exact({
      widgetName: _propTypes.default.string,
      parentName: _propTypes.default.string
    }),
    decimalType: _propTypes.default.string,
    hideBorder: _propTypes.default.bool,
    gaID: _propTypes.default.string,
    customCardHeaderHeight: _propTypes.default.string
  },
  DefaultProps: {
    theme: _constant.DEFAULT_THEME,
    accessible: true,
    columnSpan: _constant4.ARR_COLUMN_SPAN[2],
    hoverEffect: true,
    environment: 'DEVELOPMENT',
    formatPrice: false,
    allowLocaleFormat: false,
    isCnDomain: false,
    isMobile: false,
    hideBorder: false
  }
};
exports.ShoppingProductCardPropTypes = ShoppingProductCardPropTypes;
var CardHeaderPropTypes = {
  PropTypes: {
    imageUrl: _propTypes.default.string,
    imageAlt: _propTypes.default.string,
    lowResolutionImageUrl: _propTypes.default.string,
    enableProgressiveImageLoading: _propTypes.default.bool,
    lazyLoadImage: _propTypes.default.bool,
    primaryLabel: _propTypes.default.string,
    secondaryLabel: _propTypes.default.string,
    imageHoverAnimation: _propTypes.default.bool,
    customCardHeaderHeight: _propTypes.default.string,
    imageList: _propTypes.default.string
  },
  DefaultProps: {
    imageHoverAnimation: true
  }
};
exports.CardHeaderPropTypes = CardHeaderPropTypes;
var CardBodyPropTypes = {
  PropTypes: {
    timer: _propTypes.default.string,
    attractText: _propTypes.default.string,
    name: _propTypes.default.string,
    subTitle: _propTypes.default.string,
    stars: _propTypes.default.string,
    isIE: _propTypes.default.bool,
    allowLocaleFormat: _propTypes.default.bool,
    locale: _propTypes.default.string,
    localeConfig: _propTypes.default.shape({
      date: _propTypes.default.object,
      time: _propTypes.default.object
    }),
    promotionTnC: _propTypes.default.string,
    promotionCouponCode: _propTypes.default.string,
    couponBoxLabel: _propTypes.default.string,
    couponBoxCtaText: _propTypes.default.string,
    couponBoxCtaHref: _propTypes.default.string,
    subtitleExpandCtaText: _propTypes.default.string,
    isHolidaysCard: _propTypes.default.bool,
    tags: _propTypes.default.arrayOf(_propTypes.default.exact({
      key: _propTypes.default.string,
      label: _propTypes.default.string,
      url: _propTypes.default.string,
      color: _propTypes.default.oneOf(_constant.ARR_COLORS),
      backgroundColor: _propTypes.default.oneOf(_constant.ARR_COLORS),
      padding: _propTypes.default.string,
      margin: _propTypes.default.string,
      tagTarget: _propTypes.default.oneOf(Object.keys(_constant3.LINK_TARGET)),
      type: _propTypes.default.oneOf(_constant2.ARR_TEXT_TYPE),
      handleOnClick: _propTypes.default.func
    })),
    updateGtmId: _propTypes.default.func
  }
};
exports.CardBodyPropTypes = CardBodyPropTypes;
var CardFooterPropTypes = {
  PropTypes: {
    location: _propTypes.default.string,
    rating: _propTypes.default.string,
    cta: _propTypes.default.string,
    ctaConfig: _propTypes.default.shape({
      color: _propTypes.default.oneOf(_constant.ARR_COLORS),
      size: _propTypes.default.oneOf(_constant.ARR_FONT_SIZE),
      target: _propTypes.default.oneOf(Object.keys(_constant3.LINK_TARGET)),
      type: _propTypes.default.oneOf(Object.keys(_constant3.REDIRECTION_TYPE)),
      href: _propTypes.default.string.isRequired,
      callback: _propTypes.default.func,
      queryParams: _propTypes.default.object
    }),
    priceDisclaimer: _propTypes.default.string,
    discount: _propTypes.default.string,
    originalPrice: _propTypes.default.string,
    price: _propTypes.default.string,
    priceClarification: _propTypes.default.string,
    url: _propTypes.default.string,
    isIE: _propTypes.default.bool,
    cardIndex: _propTypes.default.number,
    decimalType: _propTypes.default.string,
    updateGtmId: _propTypes.default.func,
    gaID: _propTypes.default.string,
    pricePrefix: _propTypes.default.string,
    isHolidaysCard: _propTypes.default.string
  }
};
exports.CardFooterPropTypes = CardFooterPropTypes;
var PromotionSubtitlePropTypes = {
  PropTypes: {
    textType: _propTypes.default.oneOf(_constant2.ARR_TEXT_TYPE),
    textDir: _propTypes.default.oneOf(_constant2.TEXT_DIRECTION),
    text: _propTypes.default.string,
    promotionTnC: _propTypes.default.string,
    promotionCouponCode: _propTypes.default.string,
    couponBoxLabel: _propTypes.default.string,
    couponBoxCtaText: _propTypes.default.string,
    couponBoxCtaHref: _propTypes.default.string,
    subtitleExpandCtaText: _propTypes.default.string,
    updateGtmId: _propTypes.default.func
  }
};
exports.PromotionSubtitlePropTypes = PromotionSubtitlePropTypes;